export default __webpack_public_path__ + "static/ipg-c3448a3680b69eb55fdaac787471aee9.svg";